import StudentDashboardSidebarModule from './containers/studentDashboardSidebarModule'

export {default as StudentDashboardSidebarModuleLayout} from './components/studentDashboardSidebarModuleLayout'

export default StudentDashboardSidebarModule
